module.exports = __webpack_public_path__ + "assets/img/section-1-part-2-landing-page-bg.68d6913c.jpg";